import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar/Navbar";
import SidePanel from "../components/SidePanel/SidePanel";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import Map from "../components/Map/Map"; // Import Map component
import L from "leaflet";
import "leaflet/dist/leaflet.css"; // Ensure Leaflet styles are imported
import "./Home.css";


// Custom marker icons for confidence levels
const highConfidenceIcon = L.divIcon({
  className: "custom-fire-marker",
  html: '<div style="background-color:red;width:12px;height:12px;border-radius:50%;"></div>',
});

const nominalConfidenceIcon = L.divIcon({
  className: "custom-fire-marker",
  html: '<div style="background-color:orange;width:10px;height:10px;border-radius:50%;"></div>',
});

const lowConfidenceIcon = L.divIcon({
  className: "custom-fire-marker",
  html: '<div style="background-color:yellow;width:8px;height:8px;border-radius:50%;"></div>',
});

const Home = () => {
  const [fireData, setFireData] = useState([]);
  const [filters, setFilters] = useState({
    country: "IND", // Set default country to "IND"
    satellite: "Aqua",
    instrument: "MODIS",
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [todayDate, setTodayDate] = useState("");

  // Get today's date dynamically
  const getTodayDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  function getYesterdayDate() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Format the date (optional)
    const year = yesterday.getFullYear();
    const month = String(yesterday.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(yesterday.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`; // e.g., "2024-12-15"
}



  const fetchFireData = async () => {
    try {
      if (!filters.country) {
        alert("Please select a country before fetching data.");
        return;
      }

      // Use the country abbreviation from the filters
      // const date = getTodayDate(); // Get today's date
      const date = getYesterdayDate()
      console.log(`Yesterday date is ${date}`);
      
      const url = `https://firms.modaps.eosdis.nasa.gov/api/country/csv/19a31728e751ba62427f527f19bd54e8/${filters.instrument}_NRT/${filters.country}/1/${date}/${date}`;
      // const url = `https://firms.modaps.eosdis.nasa.gov/api/country/csv/19a31728e751ba62427f527f19bd54e8/${filters.instrument}_NRT/${filters.country}/1/2024-12-15/2024-12-15`;

      const response = await fetch(url);
      
      const data = await response.text(); // CSV data
      console.log(data);
      

      // Parse CSV data
      const parsedData = parseCSV(data);
      setFireData(parsedData);
    } catch (error) {
      console.error("Error fetching fire data:", error);
    }
  };

  // Function to parse CSV into JSON
  const parseCSV = (csvData) => {
    const lines = csvData.trim().split("\n");
    const headers = lines[0].split(",");

    return lines.slice(1).map((line) => {
      const values = line.split(",");
      return headers.reduce((acc, header, index) => {
        acc[header.trim()] = values[index]?.trim();
        return acc;
      }, {});
    });
  };

  useEffect(() => {
    setTodayDate(getTodayDate()); // Set today's date on component mount
  }, []);

  useEffect(() => {
    if (filters.country && todayDate) {
      fetchFireData(); // Fetch fire data when country or date is selected/changed
    }
  }, [filters, todayDate]);

  const applyFilters = (newFilters) => {
    setFilters(newFilters); // Update filters in the state
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
  <div className="home">
      <Navbar toggleSidebar={toggleSidebar} />
      <div
        className={`${isSidebarOpen ? "sidebar-open" : ""}`}
        style={{ display: "flex", height: "100vh" }}
      >
        <SidePanel
          applyFilters={applyFilters}
          currentFilters={filters}
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />
        <div className="map-container" style={{ flex: 1 }}>
          <MapContainer center={[20, 77]} zoom={5} style={{ height: "100%", width: "100%" }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {fireData.map((fire, index) => {
              const lat = parseFloat(fire.latitude);
              const lon = parseFloat(fire.longitude);
              const brightness = fire.brightness || "Unknown";
              const confidence = parseFloat(fire.confidence);

              // Skip invalid coordinates
              if (isNaN(lat) || isNaN(lon)) return null;

              // Determine marker icon based on confidence level
              let markerIcon = lowConfidenceIcon; // Default to low confidence
              if (confidence >= 81) markerIcon = highConfidenceIcon;
              else if (confidence >= 41) markerIcon = nominalConfidenceIcon;

              return (
                <Marker key={index} position={[lat, lon]} icon={markerIcon}>
                  <Popup>
                    <strong>Brightness: {brightness}</strong>
                    <br />
                    <p>Date: {fire.acq_date}</p>
                    <p>Location: {lat.toFixed(2)}, {lon.toFixed(2)}</p>
                    <p>Confidence: {confidence || "N/A"}</p>
                  </Popup>
                </Marker>
              );
            })}
          </MapContainer>
        </div>
      </div>
    </div>
  );
};


export default Home;
